<template>
  <div class="center self-start gap-2 b b-white bg-white p-1 i-flex">
    <base-picture
      v-for="{ method, picture } in cardPayments"
      :key="method"
      :alt="method"
      class="h-5"
      height="20"
      :props-img="{ class: 'w-a' }"
      :src="picture"
      width="36"
    />
    <!-- Paypal -->
    <base-picture
      v-if="$feature.allowPayPalAsPayment"
      alt="Paypal"
      class="h-5"
      height="20"
      :src="logos.paypal"
      width="82"
    />
    <!-- Apple Pay -->
    <base-picture
      v-if="$feature.allowApplePayAsPayment"
      :alt="$t.applePayIconText"
      class="h-5"
      height="20"
      :src="logos.applePay"
      width="47"
    />
    <!-- Klarna -->
    <base-picture
      v-if="$feature.allowKlarnaAsPayment && !auth.isEmployee"
      alt="Klarna"
      class="h-5"
      height="20"
      :src="logos.klarnaPink"
      width="50"
    />
    <!-- Google Pay -->
    <base-picture
      v-if="$feature.configGooglePay[countryCode]?.merchantId"
      alt="Google Pay"
      class="h-5"
      :src="logos.googlePay"
      width="37"
    />
  </div>
</template>

<script lang="ts" setup>
const { cardTypes } = defineProps<{
  /**
   * available CreditCardTypes
   */
  cardTypes: string[]
}>()
const { logos } = useAppConfig().assets.payment
const countryCode = useCountryCode()
const auth = useAuthStore()
const cardPayments = useCreditCards().getLogos(cardTypes)
</script>
